import React, { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { observer } from "mobx-react";
import Http from "services/Http";
import { ProgressSpinnerOverlay } from "components/ProgressSpinnerOverlay/ProgressSpinnerOverlay";
import judgmentStore from "./stores/judgment-store";
import {
  JudgmentsIntegrationPageViewModel,
//  GenerateNoticeCommand,
//  GenerateNoticeResponse,
  IntegrationCategory,
} from "./types/JudgmentIntegrationTypes";
import { JudgmentIntegrationTable } from "./components/JudgmentIntegrationTable";
import { ImportForm } from "./components/ImportForm";
import { EditForm } from "./components/EditForm";
import { ExternalImportForm } from "./components/externalImportForm";
import { ExternalEditForm } from "./components/externalEditForm";
import { JudgmentsIntegrationImportsPanel } from "./components/judgments-integration-imports-panel";
import JudgementClient from "./Api/judgment-client";
import judgementStore from "./stores/judgment-store";

import "./JudgmentIntegration.scss";
//import { Message } from "primereact/message";
import { Messages } from "primereact/messages";
//import { Button } from "react-bootstrap/lib/InputGroup";
import { Dialog } from "primereact/dialog";
import { ParsingResultsTable } from "./components/parsing-results-table";
import appSettingsStore from "./stores/appSettings-store";

export const JudgmentIntegrationsPage: React.FC<JudgmentsIntegrationPageViewModel> = observer(
  function (props) {
    const toast = React.useRef<Toast>(null);
    const importErrorMessage = useRef(null);

    const [showImportResults, setShowImportResults] = useState<boolean>();
    const [useExternalImport, setUseExternalImport] = useState<boolean>(false);

    useEffect(() => {
      judgmentStore.judgmentIntegrations = props.judgmentIntegrations;
      judgmentStore.setInitialView();
      appSettingsStore.useExternalImport().then((res => {
        setUseExternalImport(res);
      }))
      .catch(e => alert('Error retreiving application settings'));
    }, [props.judgmentIntegrations]);
    
//    const useExternal = async () => {
//      const res = await appSettingsStore.useExternalImport();
//      setUseExternalImport(res);
//    };

    const showToast = (
      severityValue: any,
      summaryValue: string,
      detailsValue?: string,
      lifetime?: number,
      sticky?: boolean
    ) => {
      if (toast.current != null) {
        toast.current.show({
          severity: severityValue,
          summary: summaryValue,
          detail: detailsValue,
          sticky: false,
          closable: true,
          life: lifetime,
        });
      } else return;
    };

    const getAllIntegrations = async () => {
      var response = await JudgementClient.getAllJudgementIntegrations();

      if (response.errors && response.errors.length > 0) {
        showToast(
          "error",
          response.message ?? "",
          response.message,
          undefined,
          true
        );
      } else {
        judgementStore.judgmentIntegrations = response.judgmentIntegrations;
      }
    };

    const backToImportsButtonClicked = () => {
      showImportErrorMessage(false);
      getAllIntegrations();
      judgmentStore.setInitialView();
    };

    const showImportErrorMessage = (show: boolean) => {
      if (importErrorMessage.current) {
        if (show) {
          importErrorMessage.current.show({
            severity: "warn",
            sticky: true,
            content: (
              <React.Fragment>
                There were some errors importing the data from the files.&nbsp;{<a href="#" onClick={() => setShowImportResults(true)}>Click here to review</a>}.
              </React.Fragment>
            ),
          });
        }
        else {
          importErrorMessage.current.clear();
        }
      }
    };

    return (
      <>
        <Toast ref={toast} />
        <Messages ref={importErrorMessage} />
        {judgmentStore.showImportForm ? (
          <>
            <div className="card p-mb-4">
              <a href="#" onClick={backToImportsButtonClicked}>
                Import History
              </a>
              <span className="p-text-normal">
                &nbsp;&gt;&nbsp;
                {judgmentStore.currentIntegration?.integrationCategoryID ===
                  IntegrationCategory.Judgment
                  ? "Judgments"
                  : "Satisfactions"}
              </span>
            </div>
          </>
        ) : null}
        {judgmentStore.showPastIntegrationsTable ? (
          <JudgmentsIntegrationImportsPanel showToast={showToast} />
        ) : null}
		    {judgmentStore.showImportForm && !useExternalImport ? (
          !judgmentStore.isEditing ?
            <ImportForm showToast={showToast} />
            : <EditForm showToast={showToast} />
        ) : null}
        {judgmentStore.showImportForm && useExternalImport ? (
          !judgmentStore.isEditing ?
            <ExternalImportForm showToast={showToast} />
            : <ExternalEditForm showToast={showToast} />
        ) : null}
        <Messages ref={importErrorMessage} />
        {judgmentStore.showImportResultsTable ? (
          <JudgmentIntegrationTable
            showToast={showToast}
            casePageUrl={props.casePageUrl}
            showImportErrorMessage={showImportErrorMessage}
          />
        ) : null}
        <ProgressSpinnerOverlay
          displayOverlay={Http.isFetchingData}
          waitMessage={Http.waitMessage}
        />
        <div>
          <Dialog
            header="Import Results"
            visible={showImportResults}
            onHide={() => setShowImportResults(false)}
            modal
            blockScroll={true}
            draggable={false}
            style={{ width: "50vw" }}
          >
            <div style={{ paddingTop: "1em", paddingBottom: "1em" }}>
              <ParsingResultsTable />
            </div>
          </Dialog>

        </div>
      </>
    );
  }
);
